<template>
	<div>
		<h2 class="text-center">Statistiques de la session</h2>
		<br/>
		<div>
			<h3>Résultats (en pourcentage de OUI) :</h3>
			<div class="form-group">
				<chart width="700" height="400" :options="barChart"></chart>
				<div>
					<div>
				        <div v-if="user" class="col-md-6 inline-div text-center">
				        	<div class="box-color1 inline-div"></div>
				        	<div class="inline-div">Vos résultats (tour 1)</div>
				        </div>
				        <div v-if="group"  class="col-md-6 inline-div text-center">
				        	<div class="box-color3 inline-div"></div>
				        	<div class="inline-div">Les résultats du groupe (tour 1)</div>
				        </div>
					</div>
					<div>
				        <div v-if="user" class="col-md-6 inline-div text-center">
				        	<div class="box-color2 inline-div"></div>
				        	<div class="inline-div">Vos résultats (tour 2)</div>
				        </div>
				        <div v-if="group" class="col-md-6 inline-div text-center">
				        	<div class="box-color4 inline-div"></div>
				        	<div class="inline-div">Les résultats du groupe (tour 2)</div>
				        </div>
					</div>
			    </div>
			</div>
			<br/>
			<div>
				<div v-if="user" class="form-group stat-table-wrapper">
					<label>Résultats du participant :</label>
					<table class="table table-bordered table-fix">
						<thead>
							<tr class="active">
								<th class="th-center">Tour</th>
								<th class="th-center" v-for="criteriaLabel in criterias.labels">
									<span v-text="criteriaLabel"></span>
								</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="userDatum in userData.criterias" style="background-color:#FFFFFF;">
								<td>
									<span v-text="userDatum.label"></span>
								</td>
								<td v-for="cellData in userDatum.data">
									<span v-text="cellData + '%'"></span>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div v-if="group" class="form-group stat-table-wrapper">
					<label>Résultats du groupe :</label>
					<table class="table table-bordered table-fix">
						<thead>
							<tr class="active">
								<th class="th-center">Tour</th>
								<th class="th-center" v-for="criteriaLabel in criterias.labels">
									<span v-text="criteriaLabel"></span>
								</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="groupDatum in groupData.criterias" style="background-color:#FFFFFF;color:#000000;">
								<td>
									<span v-text="groupDatum.label"></span>
								</td>
								<td v-for="cellData in groupDatum.data">
									<span v-text="cellData + '%'"></span>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
		<div>
			<h3>Indications des causes :</h3>
			<div class="form-group">
				<ul class="list-unstyled">
					<li v-for="(label, indexCriteria) in criterias.labels">
						<div class="form-group">
							<div class="panel panel-default">
								<div class="panel-heading">
									<h3 class="panel-title" v-text="label"></h3>
								</div>
								<div class="panel-body" v-html="criterias.texts[indexCriteria]"></div>
							</div>
						</div>
						<div class="form-group row">
							<div class="col-md-5">
								<p v-if="user">Ma réponse : {{ userData.critics[indexCriteria] }}</p>
								<chart width="350" height="350" :options="pieChart(indexCriteria)"></chart>
							</div>
							<div class="col-md-7">
								<ul class="pie-legend">
									<li v-for="(item, indexCritic) in critics">
										{{ item + ' (' + groupData.critics[indexCriteria][indexCritic].value + '%}'}}
									</li>
								</ul>
							</div>
						</div>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
import Chart from 'vue-echarts'
import 'echarts/lib/chart/bar'
import 'echarts/lib/chart/pie'
import 'echarts/lib/component/tooltip'


	export default {
		components: {
			Chart
		},
		computed: {
			userData: function() {
				return this.$store.state.statistics.results.userData;
			},
			groupData: function() {
				return this.$store.state.statistics.results.groupData;
			},
			criterias: function() {
				return this.$store.state.statistics.results.criterias;
			},
			critics: function() {
				return this.$store.state.statistics.results.critics;
			},
			barChart: function() {
				this.barChartConfig.xAxis.data = this.criterias.labels;
				if (this.user)	{
					if (this.userData.criterias[0])	{
						this.addDataSerieToBarchart('Tour 1', '#669999', this.userData.criterias[0].data);
					}
				}
				if (this.group)	{
					if (this.groupData.criterias[0])	{
						this.addDataSerieToBarchart('Tour 1', '#e7efff', this.groupData.criterias[0].data);
					}
				}
				if (this.user)	{
					if (this.userData.criterias[1])	{
						this.addDataSerieToBarchart('Tour 2', '#97bbcd', this.userData.criterias[1].data);
					}
				}
				if (this.group)	{
					if (this.groupData.criterias[1])	{
						this.addDataSerieToBarchart('Tour 2', '#e1e2df', this.groupData.criterias[1].data);
					}
				}
				return this.barChartConfig;
			}
		},
		methods: {
			addDataSerieToBarchart(name, color, data)	{
				this.barChartConfig.series.push({
		            name: name,
		            type:'bar',
		            color: [color],
		            data: data
				});
			},
			pieChart(indexCriteria)	{
				this.pieChartConfig.series[0].data = this.groupData.critics[indexCriteria];
				return this.pieChartConfig;
			},
			pieChartFormatter(name) {
				let indexCritic = this.letters.indexOf(name);
				return  this.critics[index] + ' (' + groupData.critics[indexCriteria][indexCritic].value + '%)';
			}
		},
		data: function()	{
			return {
				letters: ['A', 'B', 'C', 'D'],
				barChartConfig: {
				    tooltip : {
				        trigger: 'axis',
				        axisPointer : {
				            type : 'shadow'
				        }
				    },
				    xAxis : {
			            type : 'category',
			            data : []
					},
				    yAxis : {
				        type : 'value',
			            max: 100
					},
				    series : []
				},
				pieChartConfig: {
				    tooltip : {
				        trigger: 'item',
				        formatter: "{a} <br/>{b} : {c} ({d}%)"
				    },
				    legend: {
				    	show:true
				    },
				    series : [
				        {
				            name: 'Critiques',
				            type: 'pie',
				            data:[],
				            itemStyle: {
				                emphasis: {
				                    shadowBlur: 10,
				                    shadowOffsetX: 0,
				                    shadowColor: 'rgba(0, 0, 0, 0.5)'
				                }
				            }
				        }
				    ]
			  	}
			};
		},
		props: {
			user: {type: Boolean, default: false},
			group: {type: Boolean, default: false},
			id: {type: Number, default: 0}
		},
		beforeCreate()	{
			this.$store.commit('RESULTS_STATISTICS_UPDATED', {
		        userData: {
		            'criterias': [],
		            'critics': []
		        },
		        groupData: {
		            'criterias': [],
		            'critics': []
		        },
		        criterias:  {
		            'labels': [],
		            'texts': []
		        },
		        critics: []
		    });
		},
		created()	{
			if (!this.user && this.group)	{
				this.$store.dispatch('getSessionResultsStatistics', {
					parentTargetInstanceId: this.id ? this.id : this.$route.params.sessionId,
					callbacks: { success: (data) => {
						this.$store.commit("RESULTS_STATISTICS_UPDATED", data);
					}
				}});
			}
			else	{
				this.$store.dispatch('getInstanceResultsStatistics', {
					instanceId: this.id ? this.id : this.$route.params.instanceId,
					mode: this.user && this.group ? 2 : 1,
					callbacks: { success: (data) => {
						this.$store.commit("RESULTS_STATISTICS_UPDATED", data);
					}
				}});
			}
		}
	};
</script>


<style>
.inline-div{
   display: inline-block;
}

.box-color1{
    background-color:#669999;
    width: 20px;
    height: 20px;
    border:  1px solid black;
    margin-right: 3px;
}
.box-color2{
    background-color: #97bbcd;
    width: 20px;
    height: 20px;
    border:  1px solid black;
    margin-right: 3px;
}
.box-color3{
    background-color: #e7efff;
    width: 20px;
    height: 20px;
    border:  1px solid black;
    margin-right: 3px;
}
.box-color4{
    background-color:#e1e2df;
    width: 20px;
    height: 20px;
    border:  1px solid black;
    margin-right: 3px;
}

.stat-table-wrapper td, .stat-table-wrapper th {
    width: 55px;
}

div.stat-table-wrapper.form-group {
    /*overflow-x: scroll;*/
}

.table-fix {
    //max-width: 100%;
    table-layout: fixed;
    //width: 100%;
    text-align: center;
}

.th-center {
    width: 35px;
    text-align: center;
}

.table-fix>tfoot>tr.active>th th{
    width:35px!important;
}

.pie-legend {
    list-style-type: none;
    padding-left: 0px;
		font-size: 11px;
}

.pie-legend li {
  display: block;
  float: left;
  clear: both;
  padding: 2px;
}

.pie-legend li span {
    width: 25px;
    height: 25px;
    display: block;
    float: left;
    margin-right: 2px;
}

</style>
